import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { useTheme } from "@mui/material";
import { IconEye, IconEyeOff } from "@tabler/icons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import { axiosInstance, baseURL } from "src/api/axios";
import { UserContext } from "src/context";
import CustomTextField from "../../../components/forms/theme-elements/CustomTextField";

const AuthLogin = ({ title, subtitle, subtext }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [view, setView] = useState(false);
  const [open, setOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  // eslint-disable-next-line no-unused-vars
  const { user, setUser } = useContext(UserContext);
  const [error, setError] = useState("");
  const theme = useTheme();
  const location = useLocation();

  const sendPasswordRequest = async () => {
    setOpen(false);
    let response = await axiosInstance
      .post("/auth/forgot-password", { email: forgotEmail })
      .catch((e) => {
        setOpen(false);
        setError(
          e.response?.message || e.response?.data?.message || e?.message
        );
      });
    if (response.status < 400) {
      toast.success("Please check your email");
    }
  };
  const submit = async (e) => {
    e.preventDefault();
    let response = await axios
      .post(`${baseURL}/auth/login`, {
        phoneNumber: username,
        password,
      })
      .then((res) => res)
      .catch((e) => e);
    if (response.status === 200) {
      let { access, refresh } = response.data.tokens;
      let { role } = response.data.user;
      localStorage.setItem("token", access.token);
      localStorage.setItem("refresh", refresh.token);
      localStorage.setItem("store", JSON.stringify(response.data));
      setUser(response.data);
      if (role === "admin") {
        window.location.href = "/admin";
      } else {
        window.location.href = "/dashboard";
      }
    } else {
      setError(
        "response" in response ? response.response.data.message : response.data
      );
    }
  };

  return location?.state?.isRouted ? (
    <>
      {title ? (
        <Typography fontWeight="700" variant="h2" mb={1}>
          {title}
        </Typography>
      ) : null}

      {subtext}
      <Stack
        onKeyDown={(e) => {
          if (e.key === "Enter" && !open) {
            submit(e);
          }
        }}
      >
        <form>
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              component="label"
              htmlFor="phonenumber"
              mb="5px"
            >
              EMAIL OR MOBILE NO.
            </Typography>
            <CustomTextField
              id="phonenumber"
              variant="outlined"
              fullWidth
              setState={setUsername}
              placeholder="Enter your registered Email or phone number"
            />
          </Box>
          <Box mt="25px">
            <Typography
              variant="subtitle1"
              fontWeight={600}
              component="label"
              htmlFor="password"
              mb="5px"
            >
              PASSWORD
            </Typography>
            <Stack direction={"row"} alignItems="center">
              <CustomTextField
                id="password"
                type={view ? "text" : "password"}
                variant="outlined"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {!view ? (
                        <IconEye onClick={() => setView(!view)} />
                      ) : (
                        <IconEyeOff onClick={() => setView(!view)} />
                      )}
                    </InputAdornment>
                  ),
                }}
                placeholder="Enter your password"
                setState={setPassword}
              />
            </Stack>
          </Box>
          <Typography
            variant="caption"
            fontWeight={600}
            sx={{
              color: "red",
              display: error ? "block" : "none",
            }}
          >
            {error}
          </Typography>

          <Stack
            justifyContent="space-between"
            direction="row"
            alignItems="center"
            my={2}
          >
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Remember this Device"
              />
            </FormGroup>
            <Typography
              component={Link}
              to="#"
              fontWeight="500"
              sx={{
                textDecoration: "none",
                color: "earnpati.main",
              }}
              onClick={() => setOpen(true)}
            >
              Forgot Password ?
            </Typography>
            <Dialog
              open={open}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  sendPasswordRequest();
                }
              }}
            >
              <DialogTitle>Account recovery</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Please enter email of the account you wish to recover
                </DialogContentText>
                <TextField
                  fullWidth
                  label="Email"
                  placeholder="Enter email"
                  variant="filled"
                  type="email"
                  onChange={(e) => setForgotEmail(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button onClick={sendPasswordRequest}>Confirm</Button>
              </DialogActions>
            </Dialog>
          </Stack>
        </form>
      </Stack>
      <Box>
        <Button
          sx={{ bgcolor: theme.palette.earnpati.main, my: 2 }}
          variant="contained"
          size="large"
          fullWidth
          onClick={(e) => submit(e)}
        >
          Log In
        </Button>
        <ToastContainer />
      </Box>

      {subtitle}
    </>
  ) : (
    <Box sx={{ width: "100%" }}>
      <Typography fontWeight="700" variant="h2" mb={1}>
        Not Allowed
      </Typography>
    </Box>
  );
};

export default AuthLogin;
